import React, { Fragment } from 'react';
import DepositDetailsContent from '../../components/account/depositDetailsContent';
const Deposit = () => {
    
    return (
      <Fragment>
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">충전내역</div>
                </div>
            </div>
            <DepositDetailsContent></DepositDetailsContent>    
            
      </Fragment>
    );
};

export default Deposit;


// WEBPACK FOOTER //
// ./src/containers/Account/DepositDetails.js